export const NORTH = 'NORTH';
export const SOUTH = 'SOUTH';
export const MessageRegion = {
  NORTH: 'NORTH',
  SOUTH: 'SOUTH',
  values: () => {
    return ['NORTH', 'SOUTH'];
  },
};
